import { SceneObjectBase } from '../core/SceneObjectBase.js';

class SceneDataLayers extends SceneObjectBase {
  constructor(state) {
    super(state);
    this.addActivationHandler(() => this._onActivate());
  }
  _onActivate() {
    const { layers } = this.state;
    const deactivationHandlers = [];
    for (const layer of layers) {
      deactivationHandlers.push(layer.activate());
    }
    return () => {
      deactivationHandlers.forEach((handler) => handler());
    };
  }
}

export { SceneDataLayers };
//# sourceMappingURL=SceneDataLayers.js.map
